import React, { useRef, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCar, faTruck, faTachometerAlt, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ReactEcharts from 'echarts-for-react';
import { NavLink } from 'react-router-dom';

import API_PATH from "../../constants/config.json";
import { setCookie, getPrivileges } from './../../functions/Auth';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

let title = "";
let content = [];
let value_left=0;
let midblockChecked=false;
let intersectionChecked=false;
let searchChecked=false

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '98%',
    },
  },
  rootBox: {
    flexGrow: 1,
  },
  paper: {
    width: '100%',
    boxShadow: 'none',
  },
  midMainContainer: {
    background: '#fff',
    borderRadius: '5px',
    padding: '0px',
    borderRadius: '5px',
    '@media only screen and (max-width: 3500px)': {
      width: '500px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '895px',
      maxWidth: '900px',
    },
  },
  midBlock: {
    position: 'fixed',
    background: '#fff',
    left: '-2px',
    zIndex: '33',
    borderRadius: '5px',
    bottom: '5px',
    border: '1px solid #24618E',
    
    
    '@media only screen and (max-height: 820px)': {
      height: '83vh'
    },
  },
  capitalize: {
        textTransform: 'capitalize'
      },
  formHead: {
    padding: '15px 15px 15px 15px',
    overflow: 'hidden',
    '& h3': {
      color: '#24618E',
      fontSize: '25px',
      marginTop: '0px',
      marginBottom: '-10px',
    },
    '& img': {
      width: '100%',
      height: '2px',
    },
    '& h2': {
      '@media only screen and (min-width: 3501px)': {
        fontSize: '25pt',
      },
    }
  },
  teamsUl: {
    paddingLeft: '5px !important',
    paddingTop: 0,
    margin: 0,
    width: '100%',
    float: 'left',
    '& li': {
      listStyle: 'none',
      float: 'left',
      textAlign: 'center',
      marginLeft: '50px'
    },
  },
  btnIcon: {
    color: '#24618E',
    marginRight: '5px',
  },
  btnIcons: {
    color: '#24618E',
    marginRight: '5px',
    cursor: 'pointer',
  },
  fieldsetname: {
    width: 'auto',
    border: '1px solid rgba(0, 167, 93, 1)',
    margin: '10px',
    padding: '10px',
    borderRadius: '5px',
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
    }
  },
  simpleBtn: {
    marginTop: '0px',
    border: '1px solid #333',
    color: '#333',
    background: '#fff !important',
    fontSize: '12px',
    width: '110px',
  },
  floatLeftBtn: {
    float: 'left'
  },
  floatRightBtn: {
    float: 'right',
    '@media only screen and (max-width: 3500px)': {
      width: '180px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '275px',
    },
  },
  floatCenterBtn: {
    clear: 'both',
    border: '1px solid #333',
    padding: '5px 25px',
    color: '#333',
    '@media only screen and (min-width: 3501px)': {
      width: '180px',
    },
  },
  tableHead: {
    fontWeight: 'bolder',
    textAlign: 'center',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
      paddingTop: '15px !important',
    },
    padding: 0,
    '& p': {
      margin: '0',
    }
  },
  titleTD: {
    textAlign: 'left',
    padding: 0,
    '@media only screen and (max-width: 3500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
    },
  },
  dataTD: {
    textAlign: 'center',
    padding: 0,
    '@media only screen and (max-width: 3500px)': {
      fontSize: '18px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
    },
  },
  tableMidBlock: {
    '& td': {
      border: '1px solid #D7D7D7',
      padding: '5px'
    },
    '& th': {
      border: '1px solid #D7D7D7',
      padding: '5px',
      '&:first-child': {
        border: 'none',
      }
    }
  },
  topIntPanelBtn: {     
     width: '67%',
     float: 'right',
     marginBottom: '10px',
     '& button': {
       background: '#fff',
       color: '#333',
       border: '1px solid #333',
       '&:hover': {
         boxShadow: '4px 3px 3px 0px #999',
         background: '#fff',
       }
     }
  },
  echartDiv: {
    border: '1px solid #D7D7D7',
    marginTop: '-10px',
  },
  closePara: {
    '& :hover': {
      color: '#CC0000',
      cursor: 'pointer',
    }
  },
  closeIcon: {
    textAlign: 'right',
    margin: '0',
    position: 'absolute',
    top: '10px',
    cursor: 'pointer',
    color: '#24618E',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '20pt',
      right: '10px',
      width: '40px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '30pt',
      right: '15px',
      width: '60px',
    },
    '&:hover': {
      color: '#CC0000',
    }
  },
  tableMidBlock: {
    width:"100%",
    '& td': {
      border: '1px solid #D7D7D7',
      padding: '5px',
      wordBreak:"break-all"
      
      
    },
   
    '& th': {
      border: '1px solid #D7D7D7',
      '@media only screen and (max-width: 3500px)': {
        padding: '5px',
      },
      '@media only screen and (min-width: 3501px)': {
        padding: '15px 5px',
      },
    },
    '& tbody.MuiTableBody-root tr.MuiTableRow-root:nth-child(odd)': {
      backgroundColor: ' #f2f2f2 !important',
    },
  }
}));
//End Css code ...


const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

//Start MidBlock component code ...
const PopupTemplate = props => {
    
   title = props.title;
   content = props.content;
   
   midblockChecked={midblockChecked}
   intersectionChecked={intersectionChecked}
   searchChecked={searchChecked}
   value_left=-2 
   if(props.showExternalLayers){
    value_left=300
   }

   if(props.midblockChecked ||props.intersectionChecked || props.searchChecked ){
    value_left=value_left+505
   }

  let msWidth = window.innerHeight;


  // This code is use to get window viewport height
  if (window.screen.width >= 100 && window.screen.width <= 1500) {
    msWidth = window.innerWidth;
  }
  else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
    msWidth = window.innerWidth;
  }
  else if (window.screen.width >= 3501) {
    msWidth = window.innerWidth;
  }
  else {
    msWidth = window.innerWidth;
  }
  // This code is use to get window viewport height

  useEffect(() => {
    
  }, []);

  const [popuptemplateScreenWidth, setPopuptemplateScreenWidth] = React.useState(msWidth);
  const classes = useStyles();
  const myRef = useRef(null);

  // This code is use to change window viewport height
  window.onresize = function () {
    if (window.screen.width >= 100 && window.screen.width <= 1500) {
      msWidth = window.innerWidth;
      setPopuptemplateScreenWidth(msWidth);
    }
    else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
      msWidth = window.innerWidth;
      setPopuptemplateScreenWidth(msWidth);
    }
    else if (window.screen.width >= 3501) {
      msWidth = window.innerWidth;
      setPopuptemplateScreenWidth(msWidth);
    }
    else {
      msWidth = window.innerWidth;
      setPopuptemplateScreenWidth(msWidth);
    }
  };
  // This code is use to change window viewport height

  

  return (
    <React.Fragment>
      <CssBaseline />
      <div className={classes.midBlock} ref={myRef} style={{left:value_left+'px'}}>
        <Container maxWidth="sm" className={['midBlockContainer',classes.container, classes.midMainContainer]}>
          <div className={classes.formHead}>
            
            <span > {title} </span>
            
            <p className={classes.closeIcon} onClick={props.passPopValue}>
              <FontAwesomeIcon icon={faTimes} className={classes.btnIcons} title='Close' />
            </p>
            <img src={require('../../assets/images/hrimg.svg')} />
           
          </div>
          <TableContainer component={Paper}  style={{ maxHeight: '500px',"padding": "5px" }}>
                      <Table className={classes.tableMidBlock} aria-label="customized table">
                       
                        <TableBody>
                         { 
                        
                        content.map(function(item, i){
                        
                        return (<StyledTableRow>
                            <TableCell>
                            {item[0]}
                            </TableCell>
                            <TableCell>
                            {item[1]}
                            </TableCell>
                        </StyledTableRow>)
                         
                        })
                    }
                        </TableBody>
                      </Table>
                    </TableContainer> 
        </Container>
      </div>
    </React.Fragment>
  );
}

export default PopupTemplate;

//End MidBlock component code ...
